import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  cn,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@bleu.builders/ui";
import { PlusIcon } from "@radix-ui/react-icons";
import React from "react";

export const AddResourceButton = ({ text, className = "" }) => (
  <Button size="sm" className={cn("ml-auto hidden h-8 lg:flex", className)}>
    <PlusIcon className="mr-2 size-4" />
    {text}
  </Button>
);
export function AddResourceDialog({ children, title, className = "" }) {
  return (
    <Dialog>
      <DialogTrigger>
        <AddResourceButton text={title} className={className} />
      </DialogTrigger>
      <DialogContent className="sm:max-w-[550px]">{children}</DialogContent>
    </Dialog>
  );
}

export const AddResourceCardWrapper = ({ children, title, description }) => {
  return (
    <Card className="w-full max-w-none bg-background border-0 shadow-none px-0">
      <CardHeader>
        <CardTitle className="text-xl">{title}</CardTitle>
        <CardDescription className="py-0 text-sm">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
